export default "__VITE_ASSET__BLyBNvid__"